import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'decimalPipe'})
export class DecimalPipe implements PipeTransform {

  transform(value: number) {
    return Math.round(value);
  }
}
